// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"products-header_wrapper___fdcl","content":"products-header_content__MpK9j","form":"products-header_form__kMlmY"};